import React from "react";
import CircularProgress from "@mui/material/CircularProgress";

const ButtonWithProgress = ({ buttonClass, onClick }) => {
  return (
    <button type="button" className={`btn ${buttonClass}`} onClick={onClick}>
      <CircularProgress className="text-white h-auto w-17" />
    </button>
  );
};

export default ButtonWithProgress;
